import React, { useState } from 'react';
import { Box, FormControlLabel, Radio, RadioGroup, Typography } from '@material-ui/core';
import { getCardIcon, isCardValid, validateOneOffpaymentExistingCard } from './stancer.util';
import useStyles from './styles';
import EirButton from '../../../theme/EirButton';
import CustomUpdatedPopUpModal from '../../eir-porting/CustomModal/CustomUpdatedPopUpModal';
import errorIcon from '../../../mobilecomponents/images/warning.png';

/**
 * @name StancerSavedCardContainer - jclassName component for Stancer saved card payment
 * @returns {JclassName.Element} - Renders Stancer saved card component
 */
const StancerSavedCardContainer = props => {
    const {
        cards,
        setStatus,
        handleNext,
        setPaidAmount,
        payableAmount,
        setLoading,
        setHpp,
        setLoadCvc,
        graphql,
        setStep,
    } = props;
    const classes = useStyles();
    const validCards = cards?.filter(card => isCardValid(card?.cardExpiry));
    const [selectedCard, setSelectedCard] = useState(validCards?.length > 0 && null);
    const [openErrorPopup, setOpenErrorPopup] = useState(false);

    /**
     * @function handleToggleErrorPopup
     * @description Function toggle stancer status error
     */
    const handleToggleErrorPopup = () => {
        setOpenErrorPopup(!openErrorPopup);
    };

    /**
     * @function handleCardSelect - Selects card on radio button click
     * @param {object} event
     */
    const handleCardSelect = event => {
        setSelectedCard(event.target.value);
    };

    /**
     * @function handlePayment - Handles payment for selected card
     * @param {string} cardId - Card Id of selected saved card
     */
    const handlePayment = cardId => {
        validateOneOffpaymentExistingCard({
            graphql,
            setHpp,
            setLoading,
            cardId,
            setLoadCvc,
            setStep,
            payableAmount,
            setPaidAmount,
            handleNext,
            setStatus,
            setOpenErrorPopup,
        });
    };

    return (
        <Box className={validCards?.length > 1 ? classes.savedCard : classes.singleSavedCard}>
            {validCards?.length > 1 ? (
                <RadioGroup value={selectedCard} onChange={handleCardSelect}>
                    {validCards?.map(card => (
                        <Box className={classes.card} key={card?.id}>
                            <Box key={card?.id} className={classes.radioBox}>
                                <FormControlLabel
                                    value={card?.cardId}
                                    className={classes.formControl}
                                    control={<Radio className={classes.radioButton} />}
                                    label={
                                        <>
                                            <Box className={classes.cardContainer}>
                                                <Box>
                                                    <Box className={classes.cardInfo}>
                                                        {getCardIcon(card?.cardType)}
                                                        <Typography variant='body1'>
                                                            <span>
                                                                &#8226;&#8226;&#8226;&#8226;
                                                                &#8226;&#8226;&#8226;&#8226;
                                                                &#8226;&#8226;&#8226;&#8226;
                                                            </span>
                                                            {card?.lastFourDigits}
                                                        </Typography>
                                                    </Box>
                                                    <Box>
                                                        <Typography
                                                            variant='body2'
                                                            className={classes.expiry}
                                                        >
                                                            Expiry Date:&nbsp;{card?.cardExpiry}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </>
                                    }
                                />

                                {selectedCard === card?.cardId && (
                                    <Box className={classes.ctaContainer}>
                                        <EirButton
                                            variants='primaryButtonMedium'
                                            style={{ width: '100%' }}
                                            onClick={() => handlePayment(card?.cardId)}
                                        >
                                            Pay now
                                        </EirButton>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    ))}
                </RadioGroup>
            ) : (
                <>
                    <Box>
                        <Box className={classes.cardInfo}>
                            {getCardIcon(validCards[0]?.cardType)}
                            <Typography variant='body1'>
                                <span>
                                    &#8226;&#8226;&#8226;&#8226; &#8226;&#8226;&#8226;&#8226;
                                    &#8226;&#8226;&#8226;&#8226;
                                </span>
                                {validCards[0]?.lastFourDigits}
                            </Typography>
                        </Box>
                        <Box>
                            <Typography variant='body2' className={classes.expiry}>
                                Expiry Date:&nbsp;{validCards[0]?.cardExpiry}
                            </Typography>
                        </Box>
                    </Box>
                    <Box className={classes.singlectaContainer}>
                        <EirButton
                            style={{ width: '100%' }}
                            variants='primaryButtonMedium'
                            onClick={() => handlePayment(validCards[0]?.cardId)}
                        >
                            Pay now
                        </EirButton>
                    </Box>
                </>
            )}

            {openErrorPopup && (
                <Box id='my-eir-pop-up'>
                    <CustomUpdatedPopUpModal
                        open={openErrorPopup}
                        toggle={handleToggleErrorPopup}
                        cta1={{
                            text: 'Close',
                            action: () => {
                                setOpenErrorPopup(false);
                            },
                            disable: false,
                        }}
                        cta2={{ text: '', action: () => {} }}
                    >
                        <Box className={classes.successPopup}>
                            <Box className={classes.successImg}>
                                <Typography component='img' src={errorIcon} alt='failure' />
                            </Box>

                            <Typography className={classes.imgTextAdditional}>
                                Something went wrong on our end, please wait 24 hours to see if the
                                payment reflects on your account. If not, please try again.
                            </Typography>
                        </Box>
                    </CustomUpdatedPopUpModal>
                </Box>
            )}
        </Box>
    );
};

export default StancerSavedCardContainer;
